module.exports = __webpack_public_path__ + "img/logo-senai.98a25833.svg";